import _get from 'lodash/get';

export const DEFAULT_FETCH_INTERVAL_IN_SECONDS = 60;

export const STORAGE_LOCALE = '__LOCALE__';
export const STORAGE_USER_COUNTRY = '__COUNTRY_CODE__';

export const HASH_NUMBER_SEARCH_PARAM = 'uType';

export const GRAB_APP_FLAG_NAME = 's';
export const GRAB_APP_FLAG_RESULT = 'inbox';

export const GRAB_APP_LINK = _get(
  window.Grab,
  ['config', 'grabAppLink'],
  'https://grab.onelink.me/2695613898/wibsa99w',
); // NOTE:: Always fallback to this link (prevent missing grapAppLink field in config.json - only for ge-delivery)

export default {};
